import { Component, OnInit, Input } from '@angular/core';

import { ComposableService } from '../../../projects/brokerage-eapp/src/app/services/composable.service';

@Component({
  selector: 'error',
  templateUrl: './error.component.html',
  styles: []
})
export class ErrorComponent implements OnInit {
  @Input() role: string;
  constructor(
    private composableService: ComposableService,
  ){}

  ngOnInit() {
    // reset app state
    this.composableService.resetApplication();
    if(window['jhConfig'] && window['jhConfig'].Role){
      this.role = window['jhConfig'].Role ?? 'no-role';
    }
  }
}
